// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sp-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(142, 154, 205, 0.3);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: sp-fadeIn 0.2s ease;
}

.sp-modal-content {
  background: white;
  border-radius: 16px;
  width: 50%;
  max-width: 300px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: sp-slideUp 0.3s ease;
}

.sp-profile-container {
  padding: 0 24px 24px;
}

.sp-profile-header {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 32px;
  margin-bottom: 14px;
  padding-bottom: 24px;
  border-bottom: 1px solid #eef2f6;
}

.sp-avatar-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #002FA7);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 600;
  flex-shrink: 0;
}

.sp-header-info {
  flex: 1 1;
}

.sp-student-name {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.sp-student-meta {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.sp-meta-item {
  padding: 4px 12px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 14px;
  color: #475569;
}

.sp-modal-header {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
}

.sp-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.sp-modal-close:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.sp-tab-content {
  min-height: 300px;
}

.sp-info-tab {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.sp-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  background-color: #f8fafc;
  padding: 20px;
  border-radius: 12px;
}

.sp-info-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.sp-info-label {
  min-width: 120px;
  font-size: 14px;
  color: #64748b;
}

.sp-info-value {
  font-size: 15px;
  color: #1e293b;
  font-weight: 500;
}

.sp-loading,
.sp-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
}

.sp-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top-color: #002FA7;
  border-radius: 50%;
  animation: sp-spin 1s linear infinite;
  margin-bottom: 16px;
}

.sp-close-button {
  margin-top: 16px;
  padding: 10px 24px;
  background-color: #002FA7;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.sp-close-button:hover {
  background-color: #1e40af;
}

@keyframes sp-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes sp-slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes sp-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 640px) {
  .sp-modal-content {
    width: 95%;
    max-height: 90vh;
  }
  
  .sp-profile-header {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
  
  .sp-student-meta {
    justify-content: center;
  }
  
  .sp-info-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/StudentProfileStyle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".sp-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(142, 154, 205, 0.3);\n  backdrop-filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: sp-fadeIn 0.2s ease;\n}\n\n.sp-modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 50%;\n  max-width: 300px;\n  max-height: 85vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  animation: sp-slideUp 0.3s ease;\n}\n\n.sp-profile-container {\n  padding: 0 24px 24px;\n}\n\n.sp-profile-header {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 32px;\n  margin-bottom: 14px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #eef2f6;\n}\n\n.sp-avatar-circle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #2563eb, #002FA7);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.sp-header-info {\n  flex: 1;\n}\n\n.sp-student-name {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0 0 8px 0;\n}\n\n.sp-student-meta {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.sp-meta-item {\n  padding: 4px 12px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  font-size: 14px;\n  color: #475569;\n}\n\n.sp-modal-header {\n  padding: 16px 24px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.sp-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.sp-modal-close:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.sp-tab-content {\n  min-height: 300px;\n}\n\n.sp-info-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.sp-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n  background-color: #f8fafc;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.sp-info-row {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n}\n\n.sp-info-label {\n  min-width: 120px;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.sp-info-value {\n  font-size: 15px;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.sp-loading,\n.sp-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  text-align: center;\n}\n\n.sp-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e2e8f0;\n  border-top-color: #002FA7;\n  border-radius: 50%;\n  animation: sp-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n.sp-close-button {\n  margin-top: 16px;\n  padding: 10px 24px;\n  background-color: #002FA7;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.sp-close-button:hover {\n  background-color: #1e40af;\n}\n\n@keyframes sp-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes sp-slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n@keyframes sp-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 640px) {\n  .sp-modal-content {\n    width: 95%;\n    max-height: 90vh;\n  }\n  \n  .sp-profile-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 16px;\n  }\n  \n  .sp-student-meta {\n    justify-content: center;\n  }\n  \n  .sp-info-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
